export default __webpack_public_path__ + "static/media/ecommerce-size-c.6e54fce4.png";